import React from 'react'
import { Spinner } from 'react-bootstrap'

export const SpinnerLoader = () => {
  return (
    <Spinner animation="grow" role="status" className='text-danger'>
        <span className="visually-hidden">Loading...</span>
    </Spinner>
  )
}